export default __webpack_public_path__ + "static/fire_pump_b.7c66b3aabcb9f80c997f845752383780.png";